module.exports = __webpack_public_path__ + "static/media/car.002fb333.png";